import {
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselPrevious,
    CarouselNext,
} from "@/components/ui/carousel";
import { ArrowRight, ChevronLeft, ChevronRight } from "lucide-react";

const subCategories = [
    {
        title: "Bathroom Mixers & Tapware",
        image: `${process.env.REACT_APP_BLOB_URL}/www/img/bathrooms/methven-maku-tapware-gunmetal.jpg`,
        alt: "Bathroom mixers and tapware display.",
    },
    {
        title: "Showers",
        image: `${process.env.REACT_APP_BLOB_URL}/www/img/bathrooms/waipori-bronze-methven-shower-mixer.jpg`,
        alt: "Modern shower fittings and showerware.",
    },
    {
        title: "Bathroom Accessories",
        image: `${process.env.REACT_APP_BLOB_URL}/www/img/bathrooms/methven-liano-elegance-bathroom-accessories.jpg`,
        alt: "Bathroom accessories including rails, hooks, and holders.",
    },
    {
        title: "Toilets",
        image: `${process.env.REACT_APP_BLOB_URL}/www/img/bathrooms/caroma-urbaneII-bidet.jpg`,
        alt: "Contemporary toilet suite.",
    },
    {
        title: "Basins & Bottle Traps",
        image: `${process.env.REACT_APP_BLOB_URL}/www/img/bathrooms/stylus-basin.jpg`,
        alt: "Bathroom basins and bottle traps.",
    },
    {
        title: "Vanities & Cabinets",
        image: `${process.env.REACT_APP_BLOB_URL}/www/img/bathrooms/st.michel-london-50-vanity.jpg`,
        alt: "Bathroom vanity and cabinet storage.",
    },
    {
        title: "Mirrors",
        image: `${process.env.REACT_APP_BLOB_URL}/www/img/bathrooms/sola-round-led-backlit-mirror-st.michel.jpg`,
        alt: "Bathroom mirror range.",
    },
    {
        title: "Baths",
        image: `${process.env.REACT_APP_BLOB_URL}/www/img/bathrooms/elegant-bathtub-standalone.jpg`,
        alt: "Freestanding and built-in bath options.",
    },
    {
        title: "Accessible Bathroomware",
        image: `${process.env.REACT_APP_BLOB_URL}/www/img/bathrooms/caroma-accessible-bathroomware-care-collection.jpg`,
        alt: "Accessible bathroomware for compliant spaces.",
    },
];

interface SubCategoryCarouselProps {
    variant?: "dark" | "light" | "default";
}

export default function SubCategoryCarousel({
    variant = "default",
}: SubCategoryCarouselProps) {
    const isDark = variant === "dark";

    return (
        <div className={`w-full py-12 px-4 md:px-8 lg:px-16 ${variant === "dark" ? "bg-black" : variant === "default" ? "bg-gradient-to-b from-gray-50 to-gray-100" : "bg-white"}`}>
            {/* Heading */}
            {/* <div className="mb-8 max-w-7xl mx-auto">
                <h2 className={`text-3xl md:text-4xl lg:text-5xl font-bold mb-2 leading-tight ${isDark ? "text-white" : "text-gray-900"}`}>
                    <span className="hero-text-gradient-red">Bathroom</span> Sub-Categories
                </h2>
                <p className={`text-base md:text-lg leading-relaxed ${isDark ? "text-gray-400" : "text-gray-500"}`}>
                    Explore our full range of bathroom products and solutions.
                </p>
            </div> */}

            {/* Carousel */}
            <div className="relative w-full max-w-[1536px] mx-auto px-12">
                <Carousel
                    opts={{ loop: true, align: "center" }}
                    className="w-full"
                >
                    <CarouselContent>
                        {subCategories.map((item, index) => (
                            <CarouselItem
                                key={index}
                                className="basis-auto"
                            >
                                <div className="block group">
                                    {/* Square Image */}
                                    <div className="w-[272px] h-[272px] mx-auto rounded-lg overflow-hidden mb-3">
                                        <img
                                            src={item.image}
                                            alt={item.alt}
                                            loading="lazy"
                                            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                                            onError={(e) => {
                                                const target = e.target as HTMLImageElement;
                                                target.onerror = null;
                                                target.style.display = "none";
                                            }}
                                        />
                                    </div>

                                    {/* Name + Arrow below image */}
                                    <div className="flex items-center justify-between w-[272px] mx-auto px-4 sm:px-2 md:px-4 lg:px-1 xl:px-1">
                                        <span className={`text-sm font-medium transition-colors duration-200 group-hover:text-harvey-red ${isDark ? "text-white" : "text-gray-800"}`}>
                                            {item.title}
                                        </span>
                                        <ArrowRight className={`w-4 h-4 transition-all duration-200 group-hover:translate-x-1 group-hover:text-harvey-red ${isDark ? "text-gray-400" : "text-gray-500"}`} />
                                    </div>
                                </div>
                            </CarouselItem>
                        ))}
                    </CarouselContent>
                    <CarouselPrevious icon={ChevronLeft} variant="ghost" size="custom" className={`absolute -left-14 top-[136px] z-10 !size-12 [&_svg]:size-6 ${isDark ? "bg-white/10 hover:bg-white/20 border border-white/30 text-white hover:!text-harvey-red" : "bg-gray-100 hover:bg-gray-200 border border-gray-300 text-gray-600 hover:!text-harvey-red"}`} />
                    <CarouselNext icon={ChevronRight} variant="ghost" size="custom" className={`absolute -right-14 top-[136px] z-10 !size-12 [&_svg]:size-6 ${isDark ? "bg-white/10 hover:bg-white/20 border border-white/30 text-white hover:!text-harvey-red" : "bg-gray-100 hover:bg-gray-200 border border-gray-300 text-gray-600 hover:!text-harvey-red"}`} />
                </Carousel>
            </div>
        </div>
    );
}
